/**
 * @ngdoc component
 * @name catalog.component:ItxProductInfo
 * @requires ItxProductSvc,
 * @requires ItxTranslateSvc,
 * @requires logger,
 * @requires productPopupSvc,
 * @requires $q
 * @description
 * 
 * Product information details.
 * This component will show the following product information:
 * 
 * @Params - The product is not mandatory for the RECENTLY_VIEWED 
 * 
 * > Product - Show popup delegates responsibility to the component or uses a function to capture the onclick event
 * 
 * > Event Type = OUTPUT_ON || SHOW_POPUP || LINK_HREF
 * 
 * @ on-product-click="'function"
 * 
 * > type="'RECENTLY_VIEWED' || 'COMPLETE_LOOK' || 'RELATED' || 'RELATED_BUYED'" - Preferential product display
 * 
 * > dinamic-type="true || false"  - Active delegates the responsibility to the component to show the visualization of the available respecting the preference
 */

(function() {

    'use strict';

    var itxNewRelatedCmp = {
        bindings: {
            product: '<',
            excludeProducts: '<',
            type: '<',
            eventType: '<',
            onProductClick: '&',
            dinamicType: '<'
        },
        controller: itxNewRelatedCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'product-new-related.component.html'
    };

    angular.module('itxApp.common')
        .component('itxNewRelated', itxNewRelatedCmp);

    itxNewRelatedCmpCtrl.$inject = [
        'ItxProductSvc',
        'ItxTranslateSvc',
        'Product',
        'productPopupSvc',
        '$q',
        'ProductRelatedSvc',
        'ItxConfigurationSvc',
        '$scope',
        'ItxScreenSizeSvc', 
        'imProductService',
        'ItxUtilsFct',
        'CmsConfigSvc',
        'itxAkamaiSvc',
        'DUTTI_CONS',
        'CommonServices'
    ];

    function itxNewRelatedCmpCtrl( 
        ItxProductSvc,
        ItxTranslateSvc,
        Product,
        productPopupSvc,
        $q,
        ProductRelatedSvc,
        ItxConfigurationSvc,
        $scope,
        ItxScreenSizeSvc,
        imProductService,
        ItxUtilsFct,
        CmsConfigSvc,
        itxAkamaiSvc,
        DUTTI_CONS,
        CommonServices
    ){

        var _this = this;

        _this.relatedProductEnabled = false;
        _this.typesCmp = {
            recentlyViewed: 'RECENTLY_VIEWED',
            completeLook: 'COMPLETE_LOOK',
            related: 'RELATED',
            relatedBuyed: 'RELATED_BUYED'
        };
        _this.cacheTypeSearched = [];
        _this.relatedProducts = [];
        _this.relatedProductIds = [];
        _this.lookCategories = [];
        _this.showCmpRelated = false;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        _this.debugActive = false;
        _this.ids = [8457030,8325509,8316082,8316082,8461023,8234800,8235041,8234649,8431014,8447575,8499752,8440501,8457030];
        _this.brokenProducts =_.map(_this.ids, function(idNumber){
                return {id:idNumber};
            });
        
        $scope.$on('itx-shop-cart:updated', function(shopCart) {
            if(_this.relatedProductEnabled){
                _this.initialize(shopCart);
            }
        });

        $scope.$on('recent-products:update', function() {
            if(_this.relatedProductEnabled && _this.type === _this.typesCmp.recentlyViewed){
                _this.initialize();
            }
        });

        _this.$onInit = function(){

            CmsConfigSvc.getProperty('show_related_products').then(function(relatedProductEnabled) {
                
                _this.relatedProductEnabled = relatedProductEnabled;

                if(_this.relatedProductEnabled){
                    
                    if(ItxConfigurationSvc.isDebugActive()){
                        _this.debugActive = ItxConfigurationSvc.getDebugOptions().productInfo;
                    }

                    _this.initialize();
                }
            });              
        };
        
        _this.$onChanges = function(changes){
            if(_this.relatedProductEnabled){
                var somethingChanged = ( 
                    changes.product &&
                    !changes.product.isFirstChange() && 
                    changes.product.currentValue != changes.product.previousValue ||
                    changes.excludeProducts &&
                    !changes.excludeProducts.isFirstChange() && 
                    changes.excludeProducts.currentValue != changes.excludeProducts.previousValue
                );
                if (somethingChanged) {
                    _this.initialize();
                }
            }
        };
        
        _this.onClickProduct = function($event, relatedProduct){
            const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);

            if(isCookieGroupAllowed){
                inditex.setLocalStorage('LAST_RELATED', relatedProduct.id);
            }
            imProductService.eventRelatedProductClick(relatedProduct, relatedProduct.typeRelated, inditex.iPage);
            
            // Hotjar user behavior analytics
            if(typeof hj != 'undefined'){
                hj('tagRecording', ['relacionados']);
            }
            
            if(_this.eventType !== 'LINK_HREF'){
                $event.stopPropagation();
                $event.preventDefault();
            }
            
            switch (_this.eventType) {
                case 'OUTPUT_ON':
                    _this.onProductClick({product: relatedProduct});
                    break;

                case 'SHOW_POPUP':    
                    productPopupSvc.openProductPopup(relatedProduct);
                    break;
                    
                default:
                    window.location.href = relatedProduct.getUrl();
                    break;
            }

        };

        _this.initialize = function (shopCart) {
            
            if(!shopCart){
                _this.excludeProducts = _.concat(inditex.iUserJSON.shopCart.items, _this.brokenProducts );
            } else {
                _this.excludeProducts = _.concat(shopCart, _this.brokenProducts );
            }
            
            switch (_this.type) {     
                
                // Relacionados
                case _this.typesCmp.related: 
                    if(!_this.product || _this.product.isBundleBean){
                        return;
                    }
                    _this.titleByType = ItxTranslateSvc.translateCms('legacy.product.relateds');
                    ProductRelatedSvc.getProductRelated( _this.product, _this.excludeProducts ).then( function (arrayIds){
                        if(!arrayIds || arrayIds.length === 0){
                            _this._showCmp(arrayIds);
                        }
                        else{
                            _getProducts(arrayIds, null, true)
                            .then( function (arrayProducts) {

                                // Añade el tipo de producto relacionado que es
                                arrayProducts = _this.assignRelatedType(arrayProducts, 'RELATED');

                                _this._showCmp(arrayProducts); 
                            });
                        }
                      
                    });
                    break;

                // Completa tu look
                case _this.typesCmp.completeLook:

                    // Si no hay producto
                    if(!_this.product || _this.product.isBundleBean){
                        return;
                    }
                    
                    // Obtén los productos relacionados
                    _this.getProductRelatedForCompleteLook();

                    break;   
                    
                // Vistos recientemente
                case _this.typesCmp.recentlyViewed:
                    // Ultimos vistos || relacionados de ultimo visto 
                    _this.titleByType = ItxTranslateSvc.translateCms('legacy.product.recently_viewed');
                    ProductRelatedSvc.getProductsRecentlyViewed(_this.product, _this.excludeProducts)
                    .then( function (response){
                        // Filtro para los mocacos, casuística del shopcart
                        response = ProductRelatedSvc.filterProductsByMocaco(response, _this.excludeProducts);
                        if(!response || response.length === 0){
                            return;
                        }
                        else{
                            _getProducts(response, null, true)
                            .then( function (arrayProducts) {

                                // Añade el tipo de producto relacionado que es
                                arrayProducts = _this.assignRelatedType(arrayProducts, 'RECENTLY_VIEWED');

                                _this._showCmp(arrayProducts); 
                            });
                        }
                      
                    });
                    break;

                case _this.typesCmp.relatedBuyed:

                    if(!_this.product || _this.product.isBundleBean){                        
                        return; 
                    }
                    _this.titleByType = ItxTranslateSvc.translateCms('legacy.product.otherUsersBuyed');

                    // Extrae los productos relacionados con el producto que estamos viendo
                    ProductRelatedSvc.getProductBuyed(_this.product, _this.excludeProducts)
                        .then( function (arrayProductsBuyedIds) {  
                            
                            if(arrayProductsBuyedIds && arrayProductsBuyedIds.length > 0) {                                
                                
                                _getProducts(arrayProductsBuyedIds)
                                    .then( function (arrayProductsBuyed) {
                                        
                                        // Añade el tipo de producto relacionado que es
                                        arrayProductsBuyed = _this.assignRelatedType(arrayProductsBuyed, 'RELATED_BUYED');
                                                                                
                                        if(arrayProductsBuyed.length < 4) {
                                                                                        
                                            ProductRelatedSvc.getCompleteLook( _this.product, _this.excludeProducts)
                                                .then( function (arrayCategories) {
                                                    var joinArray = [];
                                                    var filterCategory;              
                                                    
                                                    // Iteramos las categorias de productos para extraer solo 2 productos de cada tipo (accesorios, camisas ...)
                                                    _.each(arrayCategories, function (category) {
                                                        if(category && category.filteredResult.length >=1 ) {
                                                            filterCategory = _.uniqBy(category.filteredResult, 'product_id');
                                                            joinArray.push(filterCategory.slice(0,10));
                                                        }
                                                    });

                                                    if(joinArray.length > 0) {
                                                        var missingProducts = 4 - arrayProductsBuyed.length;
                                                        ItxProductSvc.getCompleteLookProducts(joinArray, missingProducts)
                                                            .then( function (data) {
                                                                var filteredProducts = _.flatten(data);
                                                                filteredProducts = _this.assignRelatedType(filteredProducts, 'COMPLETE_LOOK');
                                                                _this._showCmp(_.concat(arrayProductsBuyed, filteredProducts)); 
                                                            });
                                                    } else {
                                                        // Ejecutamos función para obtener más productos relacionados
                                                        _this.getProductRelatedForBuyed(arrayProductsBuyed);
                                                    }
                                                });
                                           
                                        } else {
                                            _this._showCmp(arrayProductsBuyed); 
                                        }
                                });

                            } else {
                                _this.getProductRelatedForCompleteLook();
                            }
                        });
                    break;
                    
            }
        };


        // Función para asignar el tipo de producto relacionado que es
        _this.assignRelatedType = function(products, type) {

            _.each(products, function(product) {
                product.typeRelated = type;
            });

            return products;

        };


        // Función para obtener productos relacionados de tipo "Comprados relacionados"
        _this.getProductRelatedForBuyed = function(productsBuyed) {
                        
            // Define el número faltante de productos para llegar a 4
            var missingProducts = 4 - productsBuyed.length;

            /*
             * Obtén más productos relacionados de tipo "RELATED".
             * Esto nos devuelve un array de productos relacionados con "_this.product" de este tipo:
             * [
             *      ProductUid {
             *          section: undefined
             *          product_id: 8694843
             *          sku: undefined
             *          colorId: "800"
             *          timestamp: 1576253832900
             *          arraySku: []
             *      }
             * ]
             */

            ProductRelatedSvc.getProductRelated(_this.product, _this.excludeProducts)
                .then( function (arrayProductsRelatedIds) {
                    
                    _getProducts(arrayProductsRelatedIds, missingProducts, true)
                        .then( function (arrayProductsRelated) {
                            // Añade el tipo de producto relacionado que es
                            arrayProductsRelated = _this.assignRelatedType(arrayProductsRelated, 'RELATED');
                            _this._showCmp(_.concat(productsBuyed, arrayProductsRelated)); 
                    });
                    
                });
        };


        // Función para obtener productos relacionados de tipo "Completa tu look"
        _this.getProductRelatedForCompleteLook = function() {

            // Define el título del bloque
            _this.titleByType = ItxTranslateSvc.translateCms('legacy.product.complete_look');

            ProductRelatedSvc.getCompleteLook( _this.product, _this.excludeProducts)
                .then( function (arrayCategories) {

                    var arrayPromises = [];
                    var joinArray = [];
                    var filterCategory;              
                    
                    // Iteramos las categorias de productos para extraer solo 2 productos de cada tipo (accesorios, camisas ...)
                    _.each(arrayCategories, function (category) {

                        if(category && category.filteredResult.length >=1 ) {

                            filterCategory = _.uniqBy(category.filteredResult, 'product_id');
                            joinArray.push(filterCategory.slice(0,10));

                        }

                    });

                    if(joinArray.length > 0) {

                        arrayPromises.push(ItxProductSvc.getCompleteLookProducts(joinArray));

                        $q.all(arrayPromises)
                            .then(function(data) {

                                var filteredProducts = _.flatten(data);
                                filteredProducts = _this.assignRelatedType(filteredProducts, 'COMPLETE_LOOK');

                                // Lo pasamos a la vista
                                _this._showCmp(filteredProducts);   

                            });
                    }
                    else {
                        _this._showCmp(joinArray);
                    }

                });

        };

        // Se encarga de decidir si se mostrará el componente
        // En caso de no tener ningún producto para mostrar con el type recibido
        // Si hemos activado la variable dinamicType el componente iterará posibilidades para mostrar otro tipo de relacionados
        _this._showCmp = function(arrayProducts){
            if(arrayProducts.length > 0){
                _this.arrayProducts = arrayProducts;
                _this.showCmpRelated = true;
            } else if(_this.dinamicType){
                _this.initializeDefaultRelateds();
            }  
        };

        // Inicialización aleatoria del componente con cache de las pruebas realizadas.
        _this.initializeDefaultRelateds = function () {
            _this.cacheTypeSearched.push(_this.type);
            if( _this.cacheTypeSearched.indexOf( _this.typesCmp.related ) === -1 ){
                _this.type = _this.typesCmp.related;
                _this.initialize();
            } else if ( _this.cacheTypeSearched.indexOf( _this.typesCmp.completeLook ) === -1){
                _this.type = _this.typesCmp.completeLook;
                _this.initialize();
            } else if( _this.cacheTypeSearched.indexOf( _this.typesCmp.recentlyViewed ) === -1 )  {
                _this.type = _this.typesCmp.recentlyViewed;
                _this.initialize();
            }
        };

        // NUEVA FUNCION PARA CREAR PRODUCTOS
        function _getProducts(arrayProducts, quantity, removeDuplicates) {
            var deferred = $q.defer();
            var arrayPromises = [];
            var arrayIdsProducts = [];   

            if(removeDuplicates){
                arrayProducts = _.uniqBy(arrayProducts, 'product_id');
            }

            if(!quantity){
                quantity = 5;
            }
            // Cortamos el array en N productos
            arrayProducts = _.chunk(arrayProducts,quantity)[0];

            _.each(arrayProducts, function (p) {
                if(p && p.product_id){ arrayIdsProducts.push(p.product_id) }
            });

            // Si no tenemos productos devolvemos array vacio
            if(!arrayProducts || arrayIdsProducts.length === 0) {
                deferred.resolve(arrayIdsProducts);
            }            

            joyr.rest.xRestGetProductStock(arrayIdsProducts)
                .done(function (productStocks) {
                    
                    // Filtramos si algún producto no dispone de stock en ninguno de sus sku's
                    var arrayIdStock = _.filter(productStocks, {stocks:[{availability: 'in_stock'}]});

                    // los agrupamos por ID para facilitar el acceso 
                    var objKey = _.keyBy(arrayIdStock, 'productId');
        
                    _.each(arrayProducts, function (p,i) {
                        if(objKey[p.product_id]){
                            arrayPromises = _.concat( arrayPromises, new Product(p.product_id, p.colorId, null, null, p.sku).fetch());
                        }
                    });

                    $q.all(arrayPromises).then( function (res) {
                        var newArray = [];
                        _.each(res, function (p, i) {
                            if(p.activeDetail && p.activeDetail.colors && p.activeDetail.colors.length > 0){
                                var newProduct = _parseProductRelated(p);
                                if(newProduct){
                                    newArray = _.concat(newArray, newProduct);
                                }
                            }
                        });
                        deferred.resolve(newArray);
                    }).catch(function(){
                        deferred.reject();
                    });
                })
                .Catch(function (e) {
                    deferred.reject();
                });

            return deferred.promise;
        }

        // Esta información se debería llenar en el componente product Related nuevo
        function _parseProductRelated(p) {
            var img = ItxUtilsFct.getImageProductUrls(p.activeDetail,p.state.selectedColor.id,'relatedProduct','siluet2','grid');                                            
            if(img && img.length>0){
                if(img[0].indexOf('_5_')){
                    img[0] = img[0].replace('_5_', '_4_');
                }
                p.state.url = p.getUrl();;
                p.state.images = {
                    siluet: itxAkamaiSvc.useAkamaiImage(img[0], 299)
                };
                return p;
            } else {
                console.error('NEW-RELATED ESTE PRODUCTO SE EXCLUYE PORQUE NO TIENE IMAGENES ', p.id);
                return null;
            }
            
        }

    }

})();
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   